/**
 * Function that allow to read a especific url parameter
 * 
 * @param {*} name name of the parameter that you want to read
 * @returns return the value of the parameter
 */
export function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.has(name) ? decodeURIComponent(params.get(name)) : null;
  }

/**
 * Funtion that update the annotations that are visible, depends of the class that 
 * the user wants to see (liver, IVC, aorta)
 * 
 * @param {*} all all of the classes or a specific class
 * @param {*} annotations all the annotations in the system
 * @param {*} activeSegmentIndex the especific class that is selected
 */
export function updateActiveAnnotation(all, annotations, activeSegmentIndex){
  const showAllButton = document.getElementById('show_all');

  if (all) {
    // Cambiar imagen a 'showall_icon.png'
    showAllButton.innerHTML = `
      <img src="${require('@/assets/showall_icon.png')}" alt="Show All" style="width: 35px; height: 20px;">
    `;

    console.log("SHOW ALL ANNOTATION CLASSES");
    for (let i=0; i<annotations.length;i++){
      annotations[i].setVisible(true, null);
    }
    
  } else {
    console.log("SHOW ANNOTATION CLASS:", activeSegmentIndex);
    // Cambiar imagen a 'showall_icon.png'
    showAllButton.innerHTML = `
      <img src="${require('@/assets/showone_icon.png')}" alt="Show One" style="width: 35px; height: 20px;">
    `;

    for (let i=0; i<annotations.length;i++){
      annotations[i].setVisible(false, null);
    }
    annotations[activeSegmentIndex-1].setVisible(true, null);
  }
}

export function updateTextBoxView(showTextBox, cornerstoneTools){
  const showAllButton = document.getElementById('show_textbox');
  const style = cornerstoneTools.annotation.config.style.getDefaultToolStyles();

  if (showTextBox) {
    // Cambiar imagen a 'showall_icon.png'
    showAllButton.innerHTML = `
      <img src="${require('@/assets/showtextbox_icon.png')}" alt="Show textbox" style="width: 25px; height: 25px;">
    `;
    
    style.global.textBoxVisibility = showTextBox;
    cornerstoneTools.annotation.config.style.setDefaultToolStyles(style);
    console.log('🔕 TextBoxes ocultos');

  } else {
    // Cambiar imagen a 'showall_icon.png'
    showAllButton.innerHTML = `
      <img src="${require('@/assets/notshowtextbox_icon.png')}" alt="Show One" style="width: 25px; height: 25px;">
    `;

    style.global.textBoxVisibility = showTextBox;
    cornerstoneTools.annotation.config.style.setDefaultToolStyles(style);
    console.log('🔕 TextBoxes ocultos');

  }
}


/**
 * Event listener to cancel the drawing event.
 * 
 * - If the "Escape" key is pressed, active manipulations are canceled.
 * - If the "Backspace" key is pressed, the selected annotation is removed.
 * 
 * @param {Event} evt The event object
 * @param {*} cornerstoneTools The cornerstone tools library
 * @param {*} annotations The list of annotations
 */
export const cancelDrawingEventListener = (evt, cornerstoneTools, annotations) => {
  const { element, key } = evt.detail;
  if (key === 'Escape') {
    if (process.env.VUE_APP_DEBUG === "true") {
        console.log("Escape");
    }
    cornerstoneTools.cancelActiveManipulations(element);
  }
  if (key === 'Backspace') {
    if (process.env.VUE_APP_DEBUG === "true") {
        console.log("backspace");
    }
    var an = cornerstoneTools.annotation.state.getAnnotation(cornerstoneTools.annotation.selection.getAnnotationsSelected()[0]);
    for (let i=0; i<annotations.length;i++){
      annotations[i].remove(an.annotationUID);
    }
    cornerstoneTools.annotation.state.removeAnnotation(cornerstoneTools.annotation.selection.getAnnotationsSelected()[0]);
  }
};

/**
 * Function to cancel the drawing event.
 * 
 * - This function cancels any active manipulations in Cornerstone.
 * - It is triggered when an event occurs.
 * 
 * @param {Event} evt The event object 
 * @param {*} cornerstoneTools cornerstoneTools The cornerstone tools library
 */
export const cancelDrawingEvent = (evt, cornerstoneTools) => {
    if (process.env.VUE_APP_DEBUG === "true") {
        console.log("cancelDrawingEvent");
    }
    const { element} = evt.detail;
    cornerstoneTools.cancelActiveManipulations(element);
  };

export function addDropdownToToolbarAnnotationClasses({
  id,
  options,
  container,
  style,
  labelText,
  onSelectedValueChange,
}) {
  const { map, defaultValue } = options;

  container = container ?? document.getElementById('toolbox');

  // Wrapper que incluye label, colorBox y select
  const wrapper = document.createElement('div');
  wrapper.style.display = 'flex';
  wrapper.style.alignItems = 'center';
  wrapper.style.gap = '8px';

  if (labelText) {
    const label = document.createElement('label');
    label.htmlFor = id;
    label.innerText = labelText;
    wrapper.appendChild(label);
  }

  // Cuadrado de color a la izquierda (refleja selección actual)
  const colorBox = document.createElement('div');
  colorBox.style.width = '20px';
  colorBox.style.height = '20px';
  colorBox.style.border = '1px solid #ccc';
  colorBox.style.borderRadius = '4px';
  wrapper.appendChild(colorBox);

  // Dropdown
  const select = document.createElement('select');
  select.id = id;

  if (style) {
    Object.assign(select.style, style);
  }

  // Añadir opciones con cuadrado unicode
  Array.from(map.entries()).forEach(([key, value]) => {
    const optionElement = document.createElement('option');
    optionElement.value = value.id;
    
    // Mostrar cuadrado de color y texto
    optionElement.textContent = `■ ${key}`;
    optionElement.style.color = value.color; // Color solo al carácter "■"

    // Guardar color original como dataset (útil si lo necesitas luego)
    optionElement.dataset.color = value.color;

    if (value.id === defaultValue) {
      optionElement.selected = true;
      colorBox.style.backgroundColor = value.color;
    }

    select.appendChild(optionElement);
  });

  // Al cambiar la selección
  select.onchange = (evt) => {
    const selectedId = Number(evt.target.value);

    const [selectedName, selectedData] = Array.from(map.entries()).find(
      ([, v]) => v.id === selectedId
    );

    colorBox.style.backgroundColor = selectedData.color;

    onSelectedValueChange(selectedId, selectedName, selectedData.color);
  };

  wrapper.appendChild(select);
  container.appendChild(wrapper);
}





// /**
//  * Function to add a dropdown menu for selecting annotation classes.
//  * 
//  * This function dynamically creates a dropdown (`<select>`) element in the specified container.
//  * It accepts a `Map` where keys are display names and values are the corresponding annotation class values.
//  * When the user selects an option, a callback function is triggered with the selected value and name.
//  *
//  * @param {Object} options - Configuration object.
//  * @param {string} id - The ID for the dropdown element.
//  * @param {Object} options - Dropdown options.
//  * @param {Map} options.map - A `Map` where keys are labels and values are option values.
//  * @param {number} options.defaultValue - The default selected value.
//  * @param {HTMLElement} container - The container where the dropdown will be appended.
//  * @param {Object} [style] - Optional styles for the dropdown.
//  * @param {string} [labelText - Optional label text to display before the dropdown.
//  * @param {Function} onSelectedValueChange - Callback function triggered when the selection changes.
//  */
// export function addDropdownToToolbarAnnotationClasses({
//   id,
//   options,
//   container,
//   style,
//   labelText,
//   onSelectedValueChange,
// }) {
//   const { map, defaultValue } = options; // Accepts a `Map` directly

//   // Set the container, defaulting to the element with ID 'toolbox' if not provided
//   container = container ?? document.getElementById('toolbox');

//   // Create a label if labelText is provided
//   if (labelText) {
//     const label = document.createElement('label');
//     label.htmlFor = id;
//     label.innerText = labelText;
//     container.append(label);
//   }

//   // Create the `<select>` dropdown element
//   const select = document.createElement('select');
//   select.id = id;

//   // Apply styles if provided
//   if (style) {
//     Object.assign(select.style, style);
//   }

//   // Populate the dropdown with options from the `Map`
//   Array.from(map.entries()).forEach(([key, value]) => {
//     const optionElement = document.createElement('option');
//     optionElement.value = value; // Assign the value from the `Map`
//     optionElement.innerText = key; // Assign the display name from the `Map`
//     if (value === defaultValue) {
//       optionElement.selected = true; // Set the default selected value
//     }
//     select.append(optionElement); // Append the option to the dropdown
//   });

//   // Assign an event listener for when the selection changes
//   select.onchange = (evt) => {
//     const selectElement = evt.target;
//     const selectedValue = Number(selectElement.value); // Get the selected value
//     const selectedName = Array.from(map.entries()).find(([v]) => v === selectedValue)?.[0]; // Find the corresponding name
//     onSelectedValueChange(selectedValue, selectedName); // Call the callback function with the value and name
//   };

//   // Append the dropdown to the specified container
//   container.append(select);
// }

/**
 * Function to add a dropdown menu for selecting annotation tools.
 * 
 * This function dynamically creates a dropdown (`<select>`) element in the specified container.
 * It allows users to select annotation tools from a given list or a `Map` object.
 * When an option is selected, a callback function is triggered with the selected value and its associated data.
 *
 * @param {Object} options - Configuration object.
 * @param {string} id - The ID for the dropdown element.
 * @param {Object} options - Dropdown options.
 * @param {Map} [options.map] - A `Map` where keys are labels and values are option data (optional).
 * @param {Array} [options.values] - An array of values to populate the dropdown (default: map keys).
 * @param {number|string} [options.defaultValue] - The default selected value.
 * @param {number} [options.defaultIndex] - The index of the default selected option if `defaultValue` is undefined.
 * @param {HTMLElement} [container] - The container where the dropdown will be appended.
 * @param {Object} [style] - Optional styles for the dropdown.
 * @param {Function} onSelectedValueChange - Callback function triggered when the selection changes.
 * @param {string} [labelText] - Optional label text displayed before the dropdown.
 */
export function addDropdownToToolbarAnnotationTool({
  id,
  options,
  container,
  style,
  onSelectedValueChange,
  labelText,
}) {
  const {
    map,
    values = [...map.keys()],
    defaultValue,
    defaultIndex = defaultValue === undefined && 0,
  } = options;
  container = container ?? document.getElementById("toolbox");


  // Create label element if labelText is provided
  if (labelText) {
    const label = document.createElement('label');
    label.htmlFor = id;
    label.innerText = labelText;
    container.append(label);
  }

  const select = document.createElement('select');
  select.id = id;

  if (style) {
    Object.assign(select.style, style);
  }

  values.forEach((value, index) => {
    const optionElement = document.createElement('option');
    const stringValue = String(value);
    optionElement.value = stringValue;
    optionElement.innerText = stringValue;
    if (value === defaultValue || index === defaultIndex) {
      optionElement.selected = true;
      if (map) {
        map.get(value).selected = true;
      }
    }
    select.append(optionElement);
  });

  select.onchange = (evt) => {
    const selectElement = evt.target;
    const { value: key } = selectElement;
    if (selectElement) {
      onSelectedValueChange(key, map?.get(key));
    }
  };

  container.append(select);
}

/**
 * Function to initialize a button with tooltip functionality.
 * 
 * @param {string} containerId - ID of the button container.
 * @param {string} buttonId - ID of the button inside the container.
 * @param {string} tooltipId - ID of the tooltip element.
 * @param {string} tooltipText - Text to display inside the tooltip.
 * @param {Function} onClick - Callback function triggered when the button is clicked.
 */
export function initializeButtonWithTooltip({
    containerId,
    buttonId,
    tooltipId,
    tooltipText,
    onClick
  }) {
    const container = document.getElementById(containerId);
    const button = container?.querySelector(`#${buttonId}`);
    const tooltip = container?.querySelector(`#${tooltipId}`);
  
    if (!container || !button || !tooltip) {
      console.error(`Error: One or more elements are missing for button ${buttonId}`);
      return;
    }
  
    // Set the tooltip text
    tooltip.textContent = tooltipText;
  
    // Assign the provided click event function
    button.onclick = () => {
      if (onClick && typeof onClick === 'function') {
        onClick(button);
      }
    };
  
    let tooltipTimeout;
  
    // Show the tooltip after 1.25 seconds on hover
    container.addEventListener('mouseover', () => {
      tooltipTimeout = setTimeout(() => {
        tooltip.classList.add('active'); // Show tooltip
      }, 1250); // 1.25 seconds
    });
  
    // Hide the tooltip when the cursor leaves the button
    container.addEventListener('mouseout', () => {
      clearTimeout(tooltipTimeout); // Cancel the timer
      tooltip.classList.remove('active'); // Hide tooltip
    });
  }

/**
 * Displays a loading indicator with animated dots.
 * @returns {number} loadingInterval - The interval ID used to control the animation.
 */
export function showLoadingIndicator() {
  // Get the DOM elements for the loading message and the dots
  const loadingDiv = document.getElementById('loading-indicator');
  const dotsSpan = document.getElementById('loading-dots');

  // Make the loading indicator visible
  loadingDiv.style.display = 'block';

  // Start with 1 dot
  let dots = 1;

  // Animate the dots: ".", "..", "...", then repeat
  const loadingInterval = setInterval(() => {
    dots = (dots % 3) + 1;
    dotsSpan.textContent = '.'.repeat(dots);
  }, 500);

  return loadingInterval;
}

/**
 * Hides the loading indicator and stops the dot animation.
 * @param {number} loadingInterval - The interval ID used for the dot animation.
 */
export function hideLoadingIndicator(loadingInterval) {
  const loadingDiv = document.getElementById('loading-indicator');

  // Hide the loading indicator
  loadingDiv.style.display = 'none';

  // Clear the animation interval if it exists
  if (loadingInterval) {
    clearInterval(loadingInterval);
  }
}